import React from 'react';
import './SurveyResponsesSurveyMonitoredIndividualCard.css';
import logComponent from '../../common/logComponent';
import MonitoredIndividualImage from '../MonitoredIndividualImage/MonitoredIndividualImage';

export default function SurveyResponsesSurveyMonitoredIndividualCard({ monitoredIndividual, selected, onClick }) {

  if (logComponent('SurveyResponsesSurveyMonitoredIndividualCard')) { console.debug('SurveyResponsesSurveyMonitoredIndividualCard rendered'); }


  const handleClick = () => {
    if (logComponent('SurveyResponsesSurveyMonitoredIndividualCard')) { console.debug('SurveyResponsesSurveyMonitoredIndividualCard handleClick'); }
    onClick(monitoredIndividual);
  }

  return (
    <li className={'Survey-Responses-Survey-Monitored-Individual-Card' + (selected ? ' Survey-Responses-Survey-Monitored-Individual-Card--selected' : '')}>
      <button onClick={handleClick}>
        <div className="Survey-Responses-Survey-Monitored-Individual-Card__image">
          {/* TODO: Conditionally render monitored individual image, once some are available */}
          <MonitoredIndividualImage monitoredIndividual={monitoredIndividual} />
        </div>
        <div>
          <p className="Survey-Responses-Survey-Monitored-Individual-Card__name">{`${monitoredIndividual.legalFirstName} ${monitoredIndividual.lastName}`}</p>
          <p className="Survey-Responses-Survey-Monitored-Individual-Card__unit">{`${monitoredIndividual.activeUnitName}`}</p>
          <p className="Survey-Responses-Survey-Monitored-Individual-Card__facility">{`${monitoredIndividual.lastKnownFacilityName}`}</p>
        </div>
      </button>
    </li>
  );
}

